<template>
  <div>
    <!-- <el-button type="text" @click="dialogVisible = true">Dialog</el-button> -->
    <div align="left" style="padding-top:40px;">
      <el-button type="primary" @click="jump('/empList')">新入社員情報登録</el-button>
      <el-button type="primary" @click="dialogCompMonthSalary = true">会社月度給与明細一覧</el-button>
      <el-button type="primary" @click="dialogCompYearSalary = true">会社年度給与明細一覧</el-button>
      <el-button type="primary" @click="uploadExcelSalary">exceltest</el-button>
    </div>
    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 39px; margin-bottom: 20px" :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('general.employee_id')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empList.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empList.salary_month')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.salary_month }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empList.account')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.account }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empList.birthday')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.birthday | formatDate }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="330px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleSalary(scope.$index, scope.row)">
            給与明細</el-button>
          <el-button size="mini" type="success" icon="el-icon-user" @click="jump('/empList')">
            社員情報変更</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 会社月度給与明細一覧 -->
    <el-dialog title="会社月度給与明細一覧" :visible.sync="dialogCompMonthSalary" width="75%" :before-close="handleClose">
      <div style="text-align:left;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
          <el-row>
            <el-col :span="3">
              <el-form-item label="年" prop="year" size="mini" style="width: 100%;">
                <el-date-picker v-model="ruleForm.year" type="year" placeholder="選択" style="width:100px;" value-format="yyyy"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="月" prop="month" size="mini" style="width: 100%;">
                <el-select v-model="ruleForm.month" style="width:80px;" placeholder="選択">
                  <el-option v-for="item in salary_months" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="compMonthSalary" size="mini">検索</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="dialogSendMailTotally = true" size="mini">送信</el-button>
            </el-col>
            <el-col :span="14">
              <div style="text-align:right;">
                <el-button type="primary" @click="printCompMonthSalary('ruleForm')" size="mini">月度給与明細一覧印刷</el-button>
                <el-button type="primary" @click="printSocialInsurance('ruleForm')" size="mini">社会保険料一覧印刷</el-button>
                <el-button type="primary" @click="printSalaryBank('ruleForm')" size="mini">総合振込依頼書印刷</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="padding-top:30px;">
        <el-table :data="compMonthSalaryData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
          <el-table-column label="社員番号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.employee_id }}</span>
            </template>
          </el-table-column>

          <el-table-column label="氏名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="総支給額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.salary_total }}</span>
            </template>
          </el-table-column>

          <el-table-column label="控除合計額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.deduction_total }}</span>
            </template>
          </el-table-column>

          <el-table-column label="差引支給額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.actually_payment }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="110px">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="sendSalaryTableMonth(scope.$index, scope.row)">送信</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pages" style="padding-top:20px;">
        <el-pagination background :disabled="disablePage" :current-page.sync="currentPage3" small layout="prev, pager, next" :page-size="pageSize" :total="total3" @current-change="compMonthSalaryChange">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="cancel()" type="primary" size="medium">{{ $t("general.close") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 会社年度給与明細一覧 -->
    <el-dialog title="会社年度給与明細一覧" :visible.sync="dialogCompYearSalary" width="75%" :before-close="handleClose">
      <div style="text-align:left;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
          <el-row>
            <el-col :span="3">
              <el-form-item label="年" prop="year" size="mini" style="width: 100%;">
                <el-date-picker v-model="ruleForm.year" type="year" placeholder="選択" style="width:100px;" value-format="yyyy"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="compYearSalary" size="mini">検索</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="printCompYearSalary('ruleForm')" size="mini">印刷</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="padding-top:30px;">
        <el-table :data="compYearSalaryData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
          <el-table-column label="月" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.month }}</span>
            </template>
          </el-table-column>

          <el-table-column label="総支給額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.salary_total }}</span>
            </template>
          </el-table-column>

          <el-table-column label="控除合計額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.deduction_total }}</span>
            </template>
          </el-table-column>

          <el-table-column label="差引支給額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.actually_payment }}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="pages" style="padding-top:20px;">
        <el-pagination background :disabled="disablePage" :current-page.sync="currentPage4" small layout="prev, pager, next" :page-size="pageSize" :total="total4" @current-change="compYearSalaryChange">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="cancel()" type="primary" size="medium">{{ $t("general.close") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 給与明細書作成 -->
    <el-dialog title="給与明細書作成" :visible.sync="dialogVisible" width="90%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <el-row>
          <el-col :span="12">
            <div style="text-align:left;">
              <el-form-item label="社員名">
                :&emsp;{{ruleForm.name}}
              </el-form-item>
              <el-form-item label="社員番号">
                :&emsp;{{ruleForm.employee_id}}
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="text-align:right;">
              <el-form-item>
                <el-button class="el-icon-circle-plus-outline" type="text" @click="salaryAdd">給与明細書作成（新規）
                </el-button>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="salaryDetailsData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
        <el-table-column label="年" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.year }}</span>
          </template>
        </el-table-column>

        <el-table-column label="月" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.month }}</span>
          </template>
        </el-table-column>

        <el-table-column label="総支給額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.salary_total }}</span>
          </template>
        </el-table-column>

        <el-table-column label="控除合計額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.deduction_total }}</span>
          </template>
        </el-table-column>

        <el-table-column label="差引支給額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.actually_payment }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="330px">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">編集</el-button>
            <el-button size="mini" type="danger" icon="el-icon-edit" @click="handleDelete(scope.$index, scope.row)">削除</el-button>
            <el-button size="mini" type="success" icon="el-icon-download" @click="printSalaryDetails(scope.$index, scope.row)">給与明細書</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages" style="padding-top:20px;">
        <el-pagination background :disabled="disablePage" :current-page.sync="currentPage2" small layout="prev, pager, next" :page-size="pageSize" :total="total2" @current-change="handleSalaryChange">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="close()" type="primary" size="medium">{{ $t("general.close") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- update salary -->
    <el-dialog :title="$t('general.edit')" :visible.sync="dialogUpdate" width="90%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <div style="padding-bottom:30px;">
          <el-row>
            <el-col :span="6">
              <div style="text-align:left;">
                <el-form-item label="社員名　：" prop="name" size="mini" style="width: 100%;">
                  {{ruleForm.name}}
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3">
              <div style="text-align:left;">
                <el-form-item label="年" prop="year" size="mini" style="width: 100%;">
                  <el-date-picker v-model="ruleForm.year" type="year" placeholder="選択" style="width:100px;" value-format="yyyy" readonly="readonly"></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3">
              <div style="text-align:left;">
                <el-form-item label="月" prop="month" size="mini" style="width: 100%;">
                  <el-select v-model="ruleForm.month" style="width:100px;">
                    <el-option disabled="disabled" v-for="item in salary_months" :key="item.id" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="基本給" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.basic_salary" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="時間外手当" prop="overtime_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="役職手当" prop="assignment_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.assignment_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="資格手当" prop="qualification_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.qualification_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="通勤手当" prop="commuting_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.commuting_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="立替交通費" prop="notax_commuting_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.notax_commuting_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="課税支給総合計" prop="tax_payment_total" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.tax_payment_total"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="非課税支給額合計" prop="notax_payment_total" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.notax_payment_total"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="健康保険" prop="health_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.health_insurance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="厚生年金" prop="annuity" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.annuity" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="雇用保険" prop="emp_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.emp_insurance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="介護保険" prop="care_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.care_insurance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="所得税" prop="income_tax" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.income_tax" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="住民税" prop="resident_tax" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.resident_tax" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="勤怠控除" prop="attendance_deduction" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.attendance_deduction" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="その他控除" prop="others" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.others" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="出勤日数" prop="work_days" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.work_days"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="出勤時間" prop="work_hours" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.work_hours"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="残業日数" prop="overtime_days" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_days"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="残業時間" prop="overtime_hours" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_hours"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="有給日数" prop="annual_vacation" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.annual_vacation"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <div>&nbsp;</div>
            </el-col>

            <el-col :span="3">
              <el-form-item v-if="otherForm.other_allowance1 != ''" :label="otherForm.other_allowance1" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="otherForm.other_a1_values" @change="other_allowanceChanged"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item v-if="otherForm.other_allowance2 != ''" :label="otherForm.other_allowance2" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="otherForm.other_a2_values" @change="other_allowanceChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="総支給額" prop="salary_total" size="mini" style="width: 80%;padding-top:30px;">
                <el-input v-model="ruleForm.salary_total"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="控除合計額" prop="deduction_total" size="mini" style="width: 80%;padding-top:30px;">
                <el-input v-model="ruleForm.deduction_total"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="差引支給額" prop="actually_payment" size="mini" style="width: 80%;padding-top:30px;">
                <el-input v-model="ruleForm.actually_payment"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="3">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="3">
              <div>&nbsp;</div>
            </el-col>

            <el-col :span="3">
              <el-form-item v-if="otherForm.other_deduction1 != ''" :label="otherForm.other_deduction1" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="otherForm.other_d1_values" @change="other_deductionChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item v-if="otherForm.other_deduction2 != ''" :label="otherForm.other_deduction2" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="otherForm.other_d2_values" @change="other_deductionChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateSalary('ruleForm')" style="width: 120px">保存</el-button>
        <!-- <el-button @click="dialogUpdate = false">キャンセル</el-button> -->
        <el-button @click="cancel('ruleForm')">キャンセル</el-button>
      </span>
    </el-dialog>

    <!-- add salary -->
    <el-dialog title="給与明細書作成（新規）" :visible.sync="dialogAdd" width="90%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <div style="padding-bottom:30px;">
          <el-row>
            <el-col :span="6">
              <div style="text-align:left;">
                <el-form-item label="社員名　：" prop="name" size="mini" style="width: 100%;">
                  {{ruleForm.name}}
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3">
              <div style="text-align:left;">
                <el-form-item label="年" prop="year" size="mini" style="width: 100%;">
                  <el-date-picker v-model="ruleForm.year" type="year" placeholder="選択" @change="isNotExisting" style="width:100px;" value-format="yyyy"></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3">
              <div style="text-align:left;">
                <el-form-item label="月" prop="month" size="mini" style="width: 100%;">
                  <el-select v-model="ruleForm.month" style="width:100px;" placeholder="選択" @change="isNotExisting">
                    <el-option v-for="item in salary_months" :key="item.id" :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="3">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="3">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="3">
              <el-form-item size="mini" style="width: 80%;">
                <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="dialogAllowance = true">支給項目追加</el-button>
              </el-form-item>

            </el-col>
            <el-col :span="3">
              <el-form-item size="mini" style="width: 80%;">
                <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="dialogDeduction = true">控除項目追加</el-button>
              </el-form-item>
            </el-col>

          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="基本給" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.basic_salary" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="時間外手当" prop="overtime_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="役職手当" prop="assignment_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.assignment_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="資格手当" prop="qualification_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.qualification_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="通勤手当" prop="commuting_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.commuting_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="立替交通費" prop="notax_commuting_allowance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.notax_commuting_allowance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="課税支給総合計" prop="tax_payment_total" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.tax_payment_total"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="非課税支給額合計" prop="notax_payment_total" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.notax_payment_total"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="健康保険" prop="health_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.health_insurance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="厚生年金" prop="annuity" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.annuity" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="雇用保険" prop="emp_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.emp_insurance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="介護保険" prop="care_insurance" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.care_insurance" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="所得税" prop="income_tax" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.income_tax" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="住民税" prop="resident_tax" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.resident_tax" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="勤怠控除" prop="attendance_deduction" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.attendance_deduction" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="その他控除" prop="others" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.others" @change="basicSalaryChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="出勤日数" prop="work_days" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.work_days"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="出勤時間" prop="work_hours" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.work_hours"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="残業日数" prop="overtime_days" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_days"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="残業時間" prop="overtime_hours" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.overtime_hours"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="有給日数" prop="annual_vacation" size="mini" style="width: 80%;">
                <el-input v-model="ruleForm.annual_vacation"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <div>&nbsp;</div>
            </el-col>

            <el-col :span="3">
              <el-form-item v-if="otherForm.other_allowance1 != ''" :label="otherForm.other_allowance1" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="otherForm.other_a1_values" @change="other_allowanceChanged"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item v-if="otherForm.other_allowance2 != ''" :label="otherForm.other_allowance2" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="otherForm.other_a2_values" @change="other_allowanceChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="3">
              <el-form-item label="総支給額" prop="salary_total" size="mini" style="width: 80%;padding-top:30px">
                <el-input v-model="ruleForm.salary_total"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="控除合計額" prop="deduction_total" size="mini" style="width: 80%;padding-top:30px">
                <el-input v-model="ruleForm.deduction_total"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="差引支給額" prop="actually_payment" size="mini" style="width: 80%;padding-top:30px">
                <el-input v-model="ruleForm.actually_payment"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="3">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="3">
              <div>&nbsp;</div>
            </el-col>

            <el-col :span="3">
              <el-form-item v-if="otherForm.other_deduction1 != ''" :label="otherForm.other_deduction1" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="otherForm.other_d1_values" @change="other_deductionChanged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item v-if="otherForm.other_deduction2 != ''" :label="otherForm.other_deduction2" prop="basic_salary" size="mini" style="width: 80%;">
                <el-input v-model="otherForm.other_d2_values" @change="other_deductionChanged"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSalary('ruleForm')" style="width: 120px">保存</el-button>
        <el-button @click="cancel('ruleForm')">キャンセル</el-button>
      </span>
    </el-dialog>

    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- dialog -->
    <el-dialog title="控除項目追加" :visible.sync="dialogDeduction" width="39%" :before-close="handleClose">
      <el-form :model="otherForm" :label-position="labelPosition" label-width="50px">
        <el-button style="margin-bottom:20px" type="success" size="small" @click="otherAdd1()">追加</el-button>
        <el-form-item label="名称">
          <el-input size="small" style="width:300px" v-model="otherForm.other_deduction1">666</el-input>
          <el-button type="danger" size="small" @click="resetForm1()">削除</el-button>
        </el-form-item>

        <el-form-item v-if="otherForm.other_deduction2 != ''" label="名称">
          <el-input size="small" style="width:300px" v-model="otherForm.other_deduction2"></el-input>
          <el-button type="danger" size="small" @click="resetForm2()">削除</el-button>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDeduction = false">取 消</el-button>
        <el-button type="primary" @click="dialogDeduction = false">确 定</el-button>
      </span>

    </el-dialog>

    <el-dialog title="支給項目追加" :visible.sync="dialogAllowance" width="39%" :before-close="handleClose">
      <el-form :model="otherForm" :label-position="labelPosition" label-width="80px">
        <el-button style="margin-bottom:20px" type="success" size="small" @click="otherAdd2()">追加</el-button>
        <el-form-item label="名称">
          <el-input size="small" style="width:300px" v-model="otherForm.other_allowance1"></el-input>
          <el-button type="danger" size="small" @click="resetForm3()">削除</el-button>
        </el-form-item>

        <el-form-item v-if="otherForm.other_allowance2 != ''" label="名称">
          <el-input size="small" style="width:300px" v-model="otherForm.other_allowance2"></el-input>
          <el-button type="danger" size="small" @click="resetForm4()">削除</el-button>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAllowance = false">取 消</el-button>
        <el-button type="primary" @click="dialogAllowance = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="送信一覧" :visible.sync="dialogSendMailTotally" width="50%" :before-close="handleClose">
      <div style="padding-top:30px;">
        <el-table ref="multipleTable" :data="compMonthSalaryData" highlight-current-row border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>

          <el-table-column label="社員番号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.employee_id }}</span>
            </template>
          </el-table-column>

          <el-table-column label="氏名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="メール" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.email }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="110px">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="sendSalaryTableMonth(scope.$index, scope.row)">送信</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSendMailTotally = false">取 消</el-button>
        <el-button type="primary" @click="sendSalaryTableMonthMulti()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogSendMailTotally: false,
      dialogVisible: false,
      dialogUpdate: false,
      dialogAdd: false,
      dialogDeduction: false,
      dialogAllowance: false,
      dialogCompMonthSalary: false,
      dialogCompYearSalary: false,
      disablePage: false,
      compMonthSalaryData: [],
      compYearSalaryData: [],
      srateList: [],
      tableData: [],
      multipleSelection: [],
      //个人给与明细一览数据
      salaryDetailsData: [],
      pageSize: 6,
      //首页分页
      currentPage: 1,
      //统计员工总数
      total: 0,
      //个人给与明细页面分页
      currentPage2: 1,
      //根据employee_id统计个人salary表信息总数
      total2: 0,
      currentPage3: 1,
      total3: 0,
      currentPage4: 1,
      total4: 0,
      year: "",
      labelPosition: 'right',
      otherForm: {
        other_deduction1: "",
        other_deduction2: "",
        other_d1_values: 0,
        other_d2_values: 0,
        other_allowance1: "",
        other_allowance2: "",
        other_a1_values: 0,
        other_a2_values: 0,
      },
      ruleForm: {
        // name:"",
        location: "",
        num: "",
        id: "",
        // employee_id: "",
        year: null,
        month: null,
        email: "",
        basic_salary: 0,
        overtime_allowance: 0,
        assignment_allowance: 0,
        qualification_allowance: 0,
        commuting_allowance: 0,
        notax_commuting_allowance: 0,
        tax_payment_total: 0,
        notax_payment_total: 0,
        health_insurance: 0,
        annuity: 0,
        emp_insurance: 0,
        care_insurance: 0,
        income_tax: 0,
        resident_tax: 0,
        attendance_deduction: 0,
        others: 0,
        work_days: 0,
        work_hours: 0,
        overtime_days: 0,
        overtime_hours: 0,
        annual_vacation: 0,
        salary_total: 0,
        deduction_total: 0,
        actually_payment: 0,
      },
      salary_months: [
        {
          id: 1,
          name: "1",
        },
        {
          id: 2,
          name: "2",
        },
        {
          id: 3,
          name: "3",
        },
        {
          id: 4,
          name: "4",
        },
        {
          id: 5,
          name: "5",
        },
        {
          id: 6,
          name: "6",
        },
        {
          id: 7,
          name: "7",
        },
        {
          id: 8,
          name: "8",
        },
        {
          id: 9,
          name: "9",
        },
        {
          id: 10,
          name: "10",
        },
        {
          id: 11,
          name: "11",
        },
        {
          id: 12,
          name: "12",
        },
      ],

      locationList: [
        {
          value: "北海道",
          label: this.$t("NKHK.hokkaido"),
        },
        {
          value: "青森県",
          label: this.$t("NKHK.aomori"),
        },
        {
          value: "岩手県",
          label: this.$t("NKHK.iwate"),
        },
        {
          value: "宮城県",
          label: this.$t("NKHK.miyagi"),
        },
        {
          value: "秋田県",
          label: this.$t("NKHK.akita"),
        },
        {
          value: "山形県",
          label: this.$t("NKHK.yamagata"),
        },
        {
          value: "福島県",
          label: this.$t("NKHK.fukushima"),
        },
        {
          value: "茨城県",
          label: this.$t("NKHK.ibaraki"),
        },
        {
          value: "栃木県",
          label: this.$t("NKHK.tochigi"),
        },
        {
          value: "群馬県",
          label: this.$t("NKHK.gunma"),
        },
        {
          value: "埼玉県",
          label: this.$t("NKHK.saitama"),
        },
        {
          value: "千葉県",
          label: this.$t("NKHK.chiba"),
        },
        {
          value: "東京都",
          label: this.$t("NKHK.tokyo"),
        },
        {
          value: "神奈川県",
          label: this.$t("NKHK.kanagawa"),
        },
        {
          value: "新潟県",
          label: this.$t("NKHK.niigata"),
        },
        {
          value: "富山県",
          label: this.$t("NKHK.toyama"),
        },
        {
          value: "石川県",
          label: this.$t("NKHK.ishikawa"),
        },
        {
          value: "福井県",
          label: this.$t("NKHK.fukui"),
        },
        {
          value: "山梨県",
          label: this.$t("NKHK.yamanashi"),
        },
        {
          value: "長野県",
          label: this.$t("NKHK.nagano"),
        },
        {
          value: "岐阜県",
          label: this.$t("NKHK.gifu"),
        },
        {
          value: "静岡県",
          label: this.$t("NKHK.shizuoka"),
        },
        {
          value: "愛知県",
          label: this.$t("NKHK.aichi"),
        },
        {
          value: "三重県",
          label: this.$t("NKHK.mie"),
        },
        {
          value: "滋賀県",
          label: this.$t("NKHK.shiga"),
        },
        {
          value: "京都府",
          label: this.$t("NKHK.kyoto"),
        },
        {
          value: "大阪府",
          label: this.$t("NKHK.osaka"),
        },
        {
          value: "兵庫県",
          label: this.$t("NKHK.hyogo"),
        },
        {
          value: "奈良県",
          label: this.$t("NKHK.nara"),
        },
        {
          value: "和歌山県",
          label: this.$t("NKHK.wakayama"),
        },
        {
          value: "鳥取県",
          label: this.$t("NKHK.tottori"),
        },
        {
          value: "島根県",
          label: this.$t("NKHK.shimane"),
        },
        {
          value: "岡山県",
          label: this.$t("NKHK.okayama"),
        },
        {
          value: "広島県",
          label: this.$t("NKHK.hiroshima"),
        },
        {
          value: "山口県",
          label: this.$t("NKHK.yamaguchi"),
        },
        {
          value: "徳島県",
          label: this.$t("NKHK.tokushima"),
        },
        {
          value: "香川県",
          label: this.$t("NKHK.kagawa"),
        },
        {
          value: "愛媛県",
          label: this.$t("NKHK.ehime"),
        },
        {
          value: "高知県",
          label: this.$t("NKHK.kochi"),
        },
        {
          value: "福岡県",
          label: this.$t("NKHK.fukuoka"),
        },
        {
          value: "佐賀県",
          label: this.$t("NKHK.saga"),
        },
        {
          value: "長崎県",
          label: this.$t("NKHK.nagasaki"),
        },
        {
          value: "熊本県",
          label: this.$t("NKHK.kumamoto"),
        },
        {
          value: "大分県",
          label: this.$t("NKHK.oita"),
        },
        {
          value: "宮崎県",
          label: this.$t("NKHK.miyazaki"),
        },
        {
          value: "鹿児島県",
          label: this.$t("NKHK.kagoshima"),
        },
        {
          value: "沖縄県",
          label: this.$t("NKHK.okinawa"),
        },
      ],
      value: "",
    };
  },

  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    otherAdd1() {
      this.otherForm.other_deduction2 = " ";
    },
    otherAdd2() {
      this.otherForm.other_allowance2 = " ";
    },
    resetForm1() {
      this.otherForm.other_deduction1 = "";
    },
    resetForm2() {
      this.otherForm.other_deduction2 = "";
    },
    resetForm3() {
      this.otherForm.other_allowance1 = "";
    },
    resetForm4() {
      this.otherForm.other_allowance2 = "";
    },
    //通过邮件给多人发送给与明细书
    sendSalaryTableMonthMulti() {

      let postData = this.qs.stringify(this.compMonthSalaryData);
      this.axios({
        method: "post",
        url: "/sendSalaryTableMonth",
        data: postData,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
        })
        .catch((error) => {
          console.log(error);
        });

    },
    //通过邮件发送个人月份给与明细书
    sendSalaryTableMonth(index, row) {
      let postData = this.qs.stringify({
        employee_id: row.employee_id,
        email: row.email,
        year: this.ruleForm.year,
        month: this.ruleForm.month,
      });
      this.axios({
        method: "post",
        url: "/sendSalaryTableMonth",
        data: postData,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    preview(index, row) {
      var r_name = JSON.parse(localStorage.getItem("salaryTemp_name"));
      this.axios.post("/currentUserId").then((response) => {
        console.log(response.data);
        var uid = response.data;
        var year = row.year;
        var month = row.month;
        window.open("/pdf/給与明細書-" + r_name + year + "年" + month + "月度" + "uid=" + uid + ".pdf");
      });
    },
    previewSalaryMonth(ruleForm) {
      this.axios.post("/currentUserId").then((response) => {
        console.log(response.data);
        var uid = response.data;
        var year = this.ruleForm.year;
        var month = this.ruleForm.month;
        window.open("/pdf/給与明細一覧表-" + year + "年" + month + "月度" + "uid=" + uid + ".pdf");
      });
    },
    previewSocialInsurance(ruleForm) {
      this.axios.post("/currentUserId").then((response) => {
        console.log(response.data);
        var uid = response.data;
        var year = this.ruleForm.year;
        var month = this.ruleForm.month;
        window.open("/pdf/社会保険料一覧表-" + year + "年" + month + "月度" + "uid=" + uid + ".pdf");
      });
    },
    previewSalaryBank(ruleForm) {
      this.axios.post("/currentUserId").then((response) => {
        console.log(response.data);
        var uid = response.data;
        var year = this.ruleForm.year;
        var month = this.ruleForm.month;
        window.open("/pdf/総合振込依頼書-" + year + "年" + month + "月度" + "uid=" + uid + ".pdf");
      });
    },
    printCompMonthSalary(ruleForm) {
      let postData = this.qs.stringify({
        year: this.ruleForm.year,
        month: this.ruleForm.month,
      });
      this.axios({
        method: "post",
        url: "/printSalaryListMonth",
        data: postData,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          this.previewSalaryMonth(ruleForm);
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          console.log(error);
        });
    },
    uploadExcelSalary() {
      this.axios({
        method: "post",
        url: "/uploadExcelSalary",
        data: 1,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });

        });
    },    
    printSocialInsurance(ruleForm) {
      let postData = this.qs.stringify({
        year: this.ruleForm.year,
        month: this.ruleForm.month,
      });
      this.axios({
        method: "post",
        url: "/printSocialInsurance",
        data: postData,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          this.previewSocialInsurance(ruleForm);
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          console.log(error);
        });
    },
    printSalaryBank(ruleForm) {
      let postData = this.qs.stringify({
        year: this.ruleForm.year,
        month: this.ruleForm.month,
      });
      this.axios({
        method: "post",
        url: "/printSalaryBank",
        data: postData,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          this.previewSalaryBank(ruleForm);
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          console.log(error);
        });
    },
    printSalaryDetails(index, row) {
      let postData = this.qs.stringify({
        employee_id: JSON.parse(localStorage.getItem("salaryTemp_id")),
        year: row.year,
        month: row.month,
      });
      this.axios({
        method: "post",
        url: "/printSalaryTableMonth",
        data: postData,
      })
        .then((response) => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          this.preview(index, row);
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          console.log(error);
        });
    },
    close() {
      this.dialogVisible = false;
      this.currentPage2 = 1;
    },
    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    handleSalary(index, row) {
      let postData = this.qs.stringify({
        employee_id: row.employee_id,
      });
      this.axios({
        method: "post",
        url: "/ListSalaryByEmployee_id",
        data: postData,
      })
        .then((response) => {
          this.salaryDetailsData = response.data;
          this.ruleForm.employee_id = row.employee_id;
          this.ruleForm.name = row.name;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios({
        method: "post",
        url: "/rowsSalaryByEmployee_id",
        data: postData,
      })
        .then((response) => {
          this.total2 = response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.dialogVisible = true;
      localStorage.setItem("salaryTemp_name", JSON.stringify(row.name));
      localStorage.setItem("salaryTemp_id", JSON.stringify(row.employee_id));
    },

    handleSalaryChange() {
      console.log(`this.$t("general.current_page"): ${this.currentPage}`);
      let postData = this.qs.stringify({
        page: this.currentPage2,
        employee_id: this.ruleForm.employee_id,
      });
      this.axios({
        method: "post",
        url: "/ListSalaryByEmployee_id",
        data: postData,
      })
        .then((response) => {
          this.salaryDetailsData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.axios({
        method: "post",
        url: "/rowsSalaryByEmployee_id",
        data: postData,
      })
        .then((response) => {
          this.total2 = response.data;
          // alert(this.total2);
          // alert(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleCurrentChange() {
      console.log(`this.$t("general.current_page"): ${this.currentPage}`);
      let postData = this.qs.stringify({
        page: this.currentPage,
      });
      this.axios({
        method: "post",
        url: "/pageEmpList",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleEdit(index, row) {
      this.dialogUpdate = true;
      this.ruleForm = Object.assign({}, row);
      this.ruleForm.name = JSON.parse(localStorage.getItem("salaryTemp_name"));
      // this.ruleForm.employee_id = JSON.parse(localStorage.getItem("salaryTemp_id"));  
    },
    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id,
          });
          this.axios({
            method: "post",
            url: "/deleteSalary",
            data: postData,
          })
            .then((response) => {
              this.handleSalaryChange();

              let postData = this.qs.stringify({
                // page: this.currentPage,
                employee_id: row.employee_id,
                // employee_id: this.ruleForm.employee_id,

              });
              this.axios({
                method: "post",
                url: "/ListSalaryByEmployee_id",
                data: postData,
              })
                .then((response) => {
                  this.salaryDetailsData = response.data;
                })
                .catch((error) => {
                  console.log(error);
                });
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed"),
              });
              console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled"),
          });
        });
    },
    updateSalary(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.ruleForm.id,
            employee_id: this.ruleForm.employee_id,
            basic_salary: this.ruleForm.basic_salary,
            year: this.ruleForm.year,
            month: this.ruleForm.month,
            work_days: this.ruleForm.work_days,
            commuting_allowance: this.ruleForm.commuting_allowance,
            work_hours: this.ruleForm.work_hours,
            overtime_days: this.ruleForm.overtime_days,
            overtime_hours: this.ruleForm.overtime_hours,
            assignment_allowance: this.ruleForm.assignment_allowance,
            notax_commuting_allowance: this.ruleForm.notax_commuting_allowance,
            tax_payment_total: this.ruleForm.tax_payment_total,
            notax_payment_total: this.ruleForm.notax_payment_total,
            overtime_allowance: this.ruleForm.overtime_allowance,
            qualification_allowance: this.ruleForm.qualification_allowance,
            health_insurance: this.ruleForm.health_insurance,
            annuity: this.ruleForm.annuity,
            emp_insurance: this.ruleForm.emp_insurance,
            care_insurance: this.ruleForm.care_insurance,
            income_tax: this.ruleForm.income_tax,
            resident_tax: this.ruleForm.resident_tax,
            attendance_deduction: this.ruleForm.attendance_deduction,
            others: this.ruleForm.others,
            salary_total: this.ruleForm.salary_total,
            deduction_total: this.ruleForm.deduction_total,
            actually_payment: this.ruleForm.actually_payment,
            annual_vacation: this.ruleForm.annual_vacation,
          });
          this.axios({
            method: "post",
            url: "/updateSalary",
            data: postData,
          })
            .then((response) => {
              this.handleSalaryChange();
              this.dialogUpdate = false;
              this.emptySalaryData();
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed"),
              });
              console.log(response);
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        }
      });
    },
    add(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            employee_id: this.ruleForm.employee_id,
            basic_salary: this.ruleForm.basic_salary,
            year: this.ruleForm.year,
            month: this.ruleForm.month,
            work_days: this.ruleForm.work_days,
            commuting_allowance: this.ruleForm.commuting_allowance,
            work_hours: this.ruleForm.work_hours,
            overtime_days: this.ruleForm.overtime_days,
            overtime_hours: this.ruleForm.overtime_hours,
            assignment_allowance: this.ruleForm.assignment_allowance,
            notax_commuting_allowance: this.ruleForm.notax_commuting_allowance,
            tax_payment_total: this.ruleForm.tax_payment_total,
            notax_payment_total: this.ruleForm.notax_payment_total,
            overtime_allowance: this.ruleForm.overtime_allowance,
            qualification_allowance: this.ruleForm.qualification_allowance,
            health_insurance: this.ruleForm.health_insurance,
            annuity: this.ruleForm.annuity,
            emp_insurance: this.ruleForm.emp_insurance,
            care_insurance: this.ruleForm.care_insurance,
            income_tax: this.ruleForm.income_tax,
            resident_tax: this.ruleForm.resident_tax,
            attendance_deduction: this.ruleForm.attendance_deduction,
            others: this.ruleForm.others,
            salary_total: this.ruleForm.salary_total,
            deduction_total: this.ruleForm.deduction_total,
            actually_payment: this.ruleForm.actually_payment,
            annual_vacation: this.ruleForm.annual_vacation,
          });
          this.axios({
            method: "post",
            url: "/insertSalary",
            data: postData,
          })
            .then((response) => {
              this.axios({
                method: "post",
                url: "/ListSalaryByEmployee_id",
                data: postData,
              })
                .then((response) => {
                  this.salaryDetailsData = response.data;
                  this.emptySalaryData();
                  this.$message({
                    type: "success",
                    message: this.$t("general.add_completed"),
                  });
                })
                .catch((error) => {
                  this.$message({
                    type: "warning",
                    message: this.$t("general.add_failed"),
                  });
                  console.log(error);
                });
              this.dialogAdd = false;
              console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    srateSearch() {
      let postData = this.qs.stringify({
        employee_id: 255002,
      });
      this.axios({
        method: "post",
        url: "/ListSalaryByEmployee_id",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
          this.ruleForm = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    jump(path) {
      this.$router.push(path);
    },
    deductionTotalChanged() {
      this.ruleForm.deduction_total = Math.round(Number(this.ruleForm.health_insurance) + Number(this.ruleForm.annuity) +
        Number(this.ruleForm.emp_insurance) + Number(this.ruleForm.care_insurance) +
        Number(this.ruleForm.income_tax) + Number(this.ruleForm.resident_tax) +
        Number(this.ruleForm.attendance_deduction) + Number(this.ruleForm.others));
    },
    salaryTotalChanged() {
      this.ruleForm.salary_total = Math.round(Number(this.ruleForm.basic_salary) + Number(this.ruleForm.overtime_allowance) +
        Number(this.ruleForm.assignment_allowance) + Number(this.ruleForm.qualification_allowance) +
        Number(this.ruleForm.commuting_allowance) + Number(this.ruleForm.notax_commuting_allowance));
    },
    taxPaymentTotalChanged() {
      this.ruleForm.tax_payment_total = Number(this.ruleForm.basic_salary) + Number(this.ruleForm.overtime_allowance) +
        Number(this.ruleForm.assignment_allowance) + Number(this.ruleForm.qualification_allowance) +
        Number(this.ruleForm.commuting_allowance);
    },
    noTaxPaymentTotalChanged() {
      this.ruleForm.notax_payment_total = Number(this.ruleForm.notax_commuting_allowance);
    },
    basicSalaryChanged() {
      let postData = this.qs.stringify({
        salary: Number(this.ruleForm.basic_salary) + Number(this.ruleForm.overtime_allowance) + Number(this.ruleForm.assignment_allowance) + Number(this.ruleForm.qualification_allowance) + Number(this.ruleForm.commuting_allowance),
        //num:0,
        // location:"北海道",
        workType: "一般の事業",
        employee_id: this.ruleForm.employee_id
      });
      this.axios({
        method: "post",
        url: "/ListSRate",
        data: postData,
      })
        .then((response) => {
          this.ruleForm.health_insurance = Math.round(response.data.h_half);
          this.ruleForm.annuity = Math.round(response.data.annuity_half);
          this.deductionTotalChanged();
          this.salaryTotalChanged();
          this.taxPaymentTotalChanged();
          this.noTaxPaymentTotalChanged();
          this.actuallyPaymentChanged();
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios({
        method: "post",
        url: "/taxCalcu",
        data: postData,
      })
        .then((response) => {
          this.ruleForm.income_tax = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios({
        method: "post",
        url: "/CalEmpIns",
        data: postData,
      })
        .then((response) => {
          this.ruleForm.emp_insurance = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    actuallyPaymentChanged() {
      this.ruleForm.actually_payment = Number(this.ruleForm.salary_total) - Number(this.ruleForm.deduction_total);
    },
    emptySalaryData() {
      this.ruleForm = {
        year: null,
        month: null,
        basic_salary: 0,
        overtime_allowance: 0,
        assignment_allowance: 0,
        qualification_allowance: 0,
        commuting_allowance: 0,
        notax_commuting_allowance: 0,
        tax_payment_total: 0,
        notax_payment_total: 0,
        health_insurance: 0,
        annuity: 0,
        emp_insurance: 0,
        care_insurance: 0,
        income_tax: 0,
        resident_tax: 0,
        attendance_deduction: 0,
        others: 0,
        work_days: 0,
        work_hours: 0,
        overtime_days: 0,
        overtime_hours: 0,
        annual_vacation: 0,
        salary_total: 0,
        deduction_total: 0,
        actually_payment: 0,
        employee_id: JSON.parse(localStorage.getItem("salaryTemp_id")),
        name: JSON.parse(localStorage.getItem("salaryTemp_name")),
      }
    },
    cancel(ruleForm) {
      this.dialogUpdate = false;
      this.dialogAdd = false;
      this.dialogCompMonthSalary = false;
      this.dialogCompYearSalary = false;
      this.currentPage3 = 1;
      this.currentPage4 = 1;
      this.compMonthSalaryData = [];
      this.compYearSalaryData = [];
      this.emptySalaryData();
      // this.ruleForm.name = JSON.parse(localStorage.getItem("salaryTemp_name"));

    },
    salaryAdd() {
      this.dialogAdd = true;
      this.emptySalaryData();
    },
    addSalary(ruleForm) {
      if (this.ruleForm.month != null && this.ruleForm.year != null) {
        let postData = this.qs.stringify({
          employee_id: JSON.parse(localStorage.getItem("salaryTemp_id")),
          year: this.ruleForm.year,
          month: this.ruleForm.month,
        });
        this.axios({
          method: "post",
          url: "/isNotExisting",
          data: postData,
        })
          .then((resp) => {
            if (resp.status == 200) {
              var json = resp.data;
              if (json.status == "not") {
                this.add(ruleForm);
                this.handleSalaryChange();
              } else
                if (json.status == "is") {
                  this.$message.error('選択した年月の給与明細がすでに存在しています。');
                }
            }
          })
          .catch((error) => {
            this.$message.error('エラー');
            console.log(error);
          });
      }
    },
    isNotExisting() {
      if (this.ruleForm.month != null && this.ruleForm.year != null) {
        let postData = this.qs.stringify({
          employee_id: JSON.parse(localStorage.getItem("salaryTemp_id")),
          year: this.ruleForm.year,
          month: this.ruleForm.month,
        });
        this.axios({
          method: "post",
          url: "/isNotExisting",
          data: postData,
        })
          .then((resp) => {
            if (resp.status == 200) {
              var json = resp.data;
              // if (json.status == "not") {
              //   this.$message({
              //     message: 'mmmmmm',
              //     type: 'success'
              //   });
              // } else 
              if (json.status == "is") {
                this.$message.error('選択した年月の給与明細がすでに存在しています。');
              }
            }
          })
          .catch((error) => {
            this.$message.error('エラー');
            console.log(error);
          });
      }

    },
    compMonthSalary() {
      let postData = this.qs.stringify({
        year: this.ruleForm.year,
        month: this.ruleForm.month,
        //page: this.currentPage3,
      });
      this.axios({
        method: "post",
        url: "/companySalaryByDate",
        data: postData,
      })
        .then((response) => {
          this.currentPage3 = 1;
          this.compMonthSalaryData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios({
        method: "post",
        url: "/rowsCompSalaryList",
        data: postData,
      })
        .then((response) => {
          this.total3 = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    compYearSalary() {
      let postData = this.qs.stringify({
        year: this.ruleForm.year,
        //        page: this.currentPage4,
      });
      this.axios({
        method: "post",
        url: "/companySalaryByYear",
        data: postData,
      })
        .then((response) => {
          this.currentPage4 = 1;
          this.compYearSalaryData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios({
        method: "post",
        url: "/rowsCompSalaryListYear",
        data: postData,
      })
        .then((response) => {
          this.total4 = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    compMonthSalaryChange() {
      let postData = this.qs.stringify({
        page: this.currentPage3,
        year: this.ruleForm.year,
        month: this.ruleForm.month,
      });
      this.axios({
        method: "post",
        url: "/companySalaryByDate",
        data: postData,
      })
        .then((response) => {
          this.compMonthSalaryData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios({
        method: "post",
        url: "/rowsCompSalaryList",
        data: postData,
      })
        .then((response) => {
          this.total3 = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    compYearSalaryChange() {
      let postData = this.qs.stringify({
        year: this.ruleForm.year,
        page: this.currentPage4,
      });
      this.axios({
        method: "post",
        url: "/companySalaryByYear",
        data: postData,
      })
        .then((response) => {
          this.compYearSalaryData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios({
        method: "post",
        url: "/rowsCompSalaryListYear",
        data: postData,
      })
        .then((response) => {
          this.total4 = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  created() {
    this.srateSearch();
    this.axios
      .post("/pageEmpList")
      .then((response) => {
        console.log(response.data);
        this.tableData = response.data;
      })
      .catch((error) => { });
    this.axios
      .post("/rowsEmpList")
      .then((response) => {
        this.total = response.data;

      })
      .catch((error) => { });
  },
};
</script>
<style scoped>
.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}
.style1 {
  margin-right: 130px;
  padding: 0px;
  text-align: right;
}
</style>




// WEBPACK FOOTER //
// src/components/JTKLoan.vue